import './styles/index.css'

import ReactDOM from 'react-dom/client'
import Router from './router/index.jsx'

import { ReactQueryProvider } from './lib/react-query/index.ts'
import { ModalProvider } from './features/modal-manager/index.ts'
import { reloadOnce } from './utils/chunk-reload.ts'

// Catches every failed dynamic import, including ones React never sees. If a
// reload already failed, let the error through to ChunkLoadErrorBoundary.
window.addEventListener('vite:preloadError', (event) => {
  if (reloadOnce()) event.preventDefault()
})

// Track JS execution start
performance.mark('[Rundown] JS execution start')
console.debug('[Performance] JS execution start')

const container = document.getElementById('root')

if (!container) {
  throw new Error('No React root found')
}

const root = ReactDOM.createRoot(container)

root.render(
  <ReactQueryProvider>
    <ModalProvider>
      <Router />
    </ModalProvider>
  </ReactQueryProvider>,
)
